import DOMPurify from "dompurify";
import { clientSlideImages } from "./variables/index";

import "./styles/index.css";

export const ClientSlider = (): HTMLElement => {
  const ClientSliderElement = document.createElement("div");
  ClientSliderElement.className =
    "flex flex-col items-center gap-14 overflow-hidden";

  ClientSliderElement.innerHTML = /* html */ `
    <h2 class="text-2xl  font-medium text-gray-900 text-center max-w-111 md:text-3xl">
      Mais de 3.000 clientes confiam no nosso trabalho
    </h2>

    <div class="w-full overflow-hidden relative">
        <div class="absolute left-0 top-0 h-full w-32 bg-gradient-to-r from-20% from-white to-transparent pointer-events-none z-[1]"></div>
        <div class="absolute right-0 top-0 h-full w-32 bg-gradient-to-l from-20% from-white to-transparent pointer-events-none z-[1]"></div>

        <div class="animate-slide px-[.250rem]">
            ${[...Array(2)]
              .map(
                () => /* html */ `
                        <div class="flex items-center gap-10 pl-10 md:gap-22 md:pl-22">
                            ${clientSlideImages
                              .map(
                                (image) => /* html */ `
                                <img src=${DOMPurify.sanitize(
                                  image.src,
                                )} alt=${DOMPurify.sanitize(
                                  image.alt,
                                )} class="h-16 object-contain" />
                            `,
                              )
                              .join("")}
                        </div>
            `,
              )
              .join("")}
        </div>
    </div>
  `;

  const slider = ClientSliderElement.querySelector(
    ".animate-slide",
  ) as HTMLDivElement;

  if (slider) {
    slider.addEventListener("mouseenter", () => {
      slider.style.animationPlayState = "paused";
    });

    slider.addEventListener("mouseleave", () => {
      slider.style.animationPlayState = "running";
    });
  }

  return ClientSliderElement;
};
